import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  tertiaryBlock,
  TertiaryBlockConfig,
  TertiaryBlockSize,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { StarRatingType } from "./types/prop-types";

/** StarRating Tertiary */
const blockConfig: TertiaryBlockConfig = {
  blockSize: TertiaryBlockSize.Default,
};

const minRating = 1;
const maxRating = 5;

export const StarRating = tertiaryBlock<StarRatingType>(
  blockConfig,
  ({ icon, rating }: StarRatingType) => {
    let limitedRating = rating;
    if (limitedRating < minRating) limitedRating = minRating;
    if (limitedRating > maxRating) limitedRating = maxRating;

    return (
      <Box className="tertiary-star-rating-default-v1 rating-wrapper">
        <Box className="rating-wrapper">
          {Array(limitedRating)
            .fill(limitedRating)
            .map((item, i) => (
              <Variants.IconRating
                key={`${item}-${i}`}
                icon={`${icon}` ?? "ic:round-star"}
              />
            ))}
        </Box>
      </Box>
    );
  }
);

StarRating.defaultProps = getDefaultProps<StarRatingType>(defaults);

export const Element: KameleonElement = {
  component: StarRating,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions: {},
};
